export const FrameCaption = ({ children }) => (
  <figcaption className="mb-3 flex items-center font-mono text-[11px] uppercase tracking-[0.08em] text-os-ink-4">{children}</figcaption>
);
